import { assertNever } from '@kofno/piper';
import { useExperiencesContext } from '../../ExperiencesContext';

// Drops the active search and restores the unfiltered catalog.
export function useResetSearch() {
  const { state, ready } = useExperiencesContext();

  return () => {
    switch (state.kind) {
      case 'error':
      case 'loading':
      case 'product-collections':
      case 'waiting': {
        break;
      }
      case 'product-collections-and-experiences':
      case 'searching':
      case 'experiences': {
        ready({
          ...state.resource,
          payload: { ...state.resource.payload, experiences: state.allExperiences },
        });
        break;
      }
      default: {
        assertNever(state);
      }
    }
  };
}
